// TODO: Clean this up
document.addEventListener('DOMContentLoaded', () => {
	const sliders = document.querySelectorAll('.global-measures-slider');
	sliders.forEach((slider) => {
		const slides = slider.querySelectorAll('.slide');
		const titles = slider.querySelectorAll('.slide-title');
        let currentSlide = parseInt(slider.dataset.current);
        slides[currentSlide].classList.add('current');
        // Controls for the title navigation
		titles.forEach((title, i) => {
            const button = title.querySelector('.title-button');
            if(currentSlide === i) {
                button.classList.add('current');
            } else {
                button.classList.remove('current');
            }
			button.addEventListener('click', () => {
                slides.forEach(slide => slide.classList.remove('current'));
                titles.forEach(title => title.querySelector('.title-button').classList.remove('current'));
                currentSlide = i;
                button.classList.add('current');
                slides[currentSlide].classList.add('current');
			});
		});
        // Controls for the arrow navigation
        slides.forEach((slide, i) => {
            const arrowControls = slide.querySelector('.arrow-controls');
            const prev = arrowControls.children[0];
            const next = arrowControls.children[1];
            if(i === 0) prev.disabled = true;
            if(slides.length - 1 === i) next.disabled = true;

            prev.addEventListener('click', () => {
                slide.classList.remove('current');
                currentSlide = i - 1;
                titles.forEach((title, i) => {
                    const button = title.querySelector('.title-button');
                    button.classList.remove('current');
                    if(currentSlide === i) button.classList.add('current');
                });
                slides[currentSlide].classList.add('current');

            });
            next.addEventListener('click', () => {
                slide.classList.remove('current');
                currentSlide = i + 1;
                titles.forEach((title, i) => {
                    const button = title.querySelector('.title-button');
                    button.classList.remove('current');
                    if(currentSlide === i) button.classList.add('current');
                });
                slides[currentSlide].classList.add('current');

            });
        });
	});
});
